import { render, staticRenderFns } from "./UsageFeesTokuyoLivingCostsTable.vue?vue&type=template&id=60180563&scoped=true&lang=pug"
import script from "./UsageFeesTokuyoLivingCostsTable.vue?vue&type=script&lang=ts"
export * from "./UsageFeesTokuyoLivingCostsTable.vue?vue&type=script&lang=ts"
import style0 from "./UsageFeesTokuyoLivingCostsTable.vue?vue&type=style&index=0&id=60180563&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60180563",
  null
  
)

export default component.exports